<app-modal>
	<sl-form #fc [form]="form" [fields]="formlyFields" [model]="model" [options]="formlyFormOptions"></sl-form>
</app-modal>

<ng-template #iconButtonTemplate let-row="row" let-column="column">
	<div>
		<button mat-button type="button" [color]="column.templateOptions?.color" [ngClass]="column.templateOptions?.classArray"
			[matTooltip]="column.templateOptions?.tooltip" [matTooltipPosition]="column.templateOptions?.tooltipPosition || 'above'"
			[matTooltipShowDelay]="column.templateOptions?.tooltipShowDelay || 1000" (click)="column.templateOptions?.onclick(row)"
			[disabled]="column.templateOptions?.disabled">
			<mat-icon *ngIf="column.templateOptions?.icon" mat-icon-button
				[class]="column.templateOptions?.iconClass">{{column.templateOptions?.icon}}</mat-icon>
			<span [class]="column.templateOptions?.labelClass">{{column.templateOptions?.label}}</span>
		</button>
	</div>
</ng-template>
